import {FormattedMessage} from '@pinecast/i18n';
import {useCSS} from '@pinecast/styles';

const TipJarDone = () => {
  const css = useCSS();
  return (
    <div className={css({padding: '40px 0', textAlign: 'center'})}>
      <div className={css({fontWeight: 500, marginBottom: '12px'})}>
        <FormattedMessage
          description="Title when a membership is updated"
          defaultMessage="We've updated your subscription."
        />
      </div>
      <p className={css({margin: 0})}>
        <FormattedMessage
          description="Copy when a membership is updated"
          defaultMessage="Yoru changes have been saved. You'll be billed accordingly."
        />
      </p>
    </div>
  );
};

export default TipJarDone;
